import React, { Component } from 'react';
import { base, firebaseAuth, logComponentLoad, logDashboardAction } from '../../../../config/constants.js'
import { Feed, Button } from 'semantic-ui-react';
import WhatsappSendMessage from './WhatsappSendMessage'
import ChatBubble from './ChatBubble'
import { getPrintValues, checkAdminEmail, getOrderByOrderNum } from '../algoliaDashboard/AlgoliaMiscUtils';



class WhatsappSingleChatViewNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            algoliaUser:'',
            messageLimit: 30
        }
    }


    componentDidMount() {
        console.log("105 >> mount WhatsAppSingleChatView >> ++++ componentDidMount")
        console.log("5.>> WhatsAppSingleChatView chatView +++++ syncMessages")
        // console.log("5.>> WhatsAppSingleChatView messages:" + this.state.messages.length)
        // this.syncMessages()

        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "WhatsappSingleChatViewNew");

        if ( returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("WhatsappSingleChatViewNew")) {
            console.log("5.>> WhatsAppSingleChatView messages:" + this.state.messages.length)
            this.syncMessages(this.state.messageLimit)
        }
      

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })
    }

    componentWillUnmount() {
        console.log("106 >>  componentWillUnmount WhatsAppSingleChatView >> ++++ ")
    }

    
    getMoreMessages = () => {
        console.log("+++++++ getMoreMessages");

        let tempLimit = this.state.messageLimit+30;
        console.log("messageLimit:"+tempLimit);

        this.setState({
            messageLimit:tempLimit
        })

        this.syncMessages(tempLimit);
    }

    syncMessages = (messageLimit) => {
        console.log("whtx5 chatView +++++ syncMessages this.props.match.params.number:" + this.props.match.params.number)
        console.log("messageLimit:"+messageLimit);
        base.syncState('whatsapp/' + this.props.match.params.number + "/messages", {
            //base.syncState('whatsapp/256772042849/messages/', {
            context: this,
            state: 'messages',
            asArray: true,
            queries: {
                orderByChild: 'createdDateSeconds',
                limitToLast: messageLimit
            },
            then() {
                logDashboardAction(this.state.user.email + " viewed chat for " + this.props.match.params.number, this.state.user.email, null, "WhatsappSingleChatViewNew");

            }
        });
    }



    render() {

        const ShowFeedImage = (props) => props.message.imageUrl
            ? <Feed.Extra images>
                <a>
                    <img src={props.message.imageUrl} />
                </a>
            </Feed.Extra>
            : ''

        // const singleFeed = this.state.messages.length > 0
        //     ? this.state.messages.map((message) =>
        //         <Feed.Event>
        //             <Feed.Label>
        //                 <Icon name='pencil' />
        //             </Feed.Label>
        //             <Feed.Content>
        //                 <Feed.Date>{message.timeSent}</Feed.Date>
        //                 <Feed.Summary>
        //                     {message.sentText}
        //                 </Feed.Summary>
        //                 <ShowFeedImage message={message} />
        //                 <Feed.Meta>
        //                     <Feed.Like>
        //                         {message.status}
        //                     </Feed.Like>
        //                 </Feed.Meta>
        //             </Feed.Content>
        //         </Feed.Event>
        //     )
        //     : ''

        //const singleFeed = this.state.messages.length > 0
        const singleFeed = this.state.messages.length > 0
            ? this.state.messages.map((message) =>
                <ChatBubble
                    key={message.key}
                    message={message}
                    phone={this.props.match.params.number}
                    user={this.state.user.email}
                    algoliaUser={this.state.algoliaUser} />
            )
            : ''

        const mainFeed = this.state.messages.length > 0
            ? <div>{singleFeed}</div>
            : ''

        const whatsappSendMessageUI =  this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("whatsapp_reply")
            ? <WhatsappSendMessage
                phone={this.props.match.params.number}
                user={this.state.user.email}
                algoliaUser={this.state.algoliaUser} />
            : ''

        // const mainFeed = this.state.messages.length > 0
        //     ? <Feed>{singleFeed}</Feed>
        //     : ''

        return (<div>
            <h1>{this.props.match.params.number} - {this.state.messages.length}</h1>
            <div><Button color={'orange'} onClick={this.getMoreMessages}>Get More Messages</Button></div>
            <br/>
            {mainFeed}
            {whatsappSendMessageUI}
            {/* <WhatsappSendMessage
                phone={this.props.match.params.number} 
                user={this.state.user.email}
                algoliaUser={this.state.algoliaUser} /> */}
        </div>);
    }
}

export default WhatsappSingleChatViewNew;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappSingleChatViewNew.js